import { FC } from "react";
import MultiUploadButton from "../../MultiUploadButton";
import i18n from "@/languages/index";
import { Controller, useFormContext } from "react-hook-form";

interface FileUploadFormProps {
  label?: string;
  anotherLabel?: string;
  removeLabel?: string;
  hint?: string;
  min?: number;
  max?: number;
  readOnly?: boolean;
  name: string;
}

const FileUploadForm: FC<FileUploadFormProps> = ({
  label,
  anotherLabel,
  removeLabel,
  hint,
  min,
  max,
  readOnly = false,
  name
}) => {

  const { 
    control,
    watch,
    setValue,
    getValues,
    trigger
  } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (<>
          <MultiUploadButton
            {...field}
            min={min ?? 1}
            max={max ?? 1}
            label={label ?? i18n.t('common:text.multiupload_label')}
            hint={hint ?? i18n.t('common:text.multiupload_hint')}
            anotherLabel={anotherLabel ?? i18n.t('common:text.multiupload_add_file')}
            removeLabel={removeLabel ?? i18n.t('common:text.multiupload_remove_file')}
            disabled={readOnly}
            errorText={[fieldState.error?.message]}
          />
      </>)}
    />
  );
};

export default FileUploadForm;
